import { initContract } from '@ts-rest/core';
import { z } from 'zod';
////////////////////////////////////////////////////////////////////////////////
// getPaymentDocuments
////////////////////////////////////////////////////////////////////////////////
export const PaymentDocument = z.strictObject({
    id: z.string(),
    processedAt: z.string(),
    claimNumber: z.string(),
    contractNumber: z.string().nullable(),
    policyHolder: z.string().nullable(),
    documentType: z.string(),
    documentNumber: z.string().nullable(),
    businessName: z.string().nullable(),
    documentAmount: z.number(),
    decision: z.string(),
    payoutAmount: z.number().nullable(),
    payoutRecipient: z.string().nullable(),
    payoutIban: z.string().nullable(),
    payoutReference: z.string().nullable(),
});
export const GetPaymentDocumentsQuery = z.strictObject({
    year: z.number().int(),
});
export const GetPaymentDocumentsResponse = z.strictObject({
    documents: z.array(PaymentDocument),
});
////////////////////////////////////////////////////////////////////////////////
// contract
////////////////////////////////////////////////////////////////////////////////
const c = initContract();
export const paymentDocumentsContract = c.router({
    getPaymentDocuments: {
        method: 'GET',
        path: '/get-payment-documents',
        query: GetPaymentDocumentsQuery,
        responses: {
            200: GetPaymentDocumentsResponse,
        },
    },
}, { strictStatusCodes: true, pathPrefix: '/payment-documents' });
